export enum TimeRange {
  hour = "1h",
  day = "1d",
  week = "1w",
  month = "1m",
}
